import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { GfTranslateService } from '../../../core/services/core.translate.service';

// Namespace: fields.builtIn.priority
@Injectable()
export class TrackerFieldsPriorityService {
    public default: 3;

    constructor(
        private gfTranslateService: GfTranslateService
    ) {}

    public idToLabelMap() {
        return {
        "1": this.gfTranslateService.translate("Very High"),
        "2": this.gfTranslateService.translate("High"),
        "3": this.gfTranslateService.translate("Medium"),
        "4": this.gfTranslateService.translate("Low"),
        "5": this.gfTranslateService.translate("Very Low")
        }
    }

    public getList() {
        return [
        {id: 1, value: "1", label: this.gfTranslateService.translate("Very High"), bgColorClass: 'bg-priority-1', defaultSelected: false},
        {id: 2, value: "2", label: this.gfTranslateService.translate("High"), bgColorClass: 'bg-priority-2', defaultSelected: false},
        {id: 3, value: "3", label: this.gfTranslateService.translate("Medium"), bgColorClass: 'bg-priority-3', defaultSelected: true},
        {id: 4, value: "4", label: this.gfTranslateService.translate("Low"), bgColorClass: 'bg-priority-4', defaultSelected: false},
        {id: 5, value: "5", label: this.gfTranslateService.translate("Very Low"), bgColorClass: 'bg-priority-5', defaultSelected: false},
        ];
    }

    public getDescription(priority) {
        if (_.has(this.idToLabelMap, priority)) {
            return this.idToLabelMap[priority];
        }
        return this.idToLabelMap[this.default];
    }

    public getDefault() {
        return { id: this.default,
            label: this.idToLabelMap[this.default]
        }
    }
}


// Namespace: fields.builtIn.waiting_for
@Injectable()
export class TrackerFieldsWaitingForService {
    public default: 1;
    public idToLabelMap: any;
    public list: any;
    
    constructor(
        private gfTranslateService: GfTranslateService
    ) {
        this.idToLabelMap = [this.gfTranslateService.translate("None"), this.gfTranslateService.translate("Assignee"), this.gfTranslateService.translate("Submitter")],
        this.list = [
            {id:100, value: "100", label: this.gfTranslateService.translate("None")},
            {id:1, value: "1", label: this.gfTranslateService.translate("Assignee")},
            {id:2, value: "2", label: this.gfTranslateService.translate("Submitter")}
        ];
    }

    public getList() {
        return _.clone(this.list);
    }
}

// Namespace: fields.builtIn.lock_status
@Injectable()
export class TrackerFieldsLockStatusService {
    default: any;
    idToLabelMap: any;
    list: any;
    
    constructor(
        private gfTranslateService: GfTranslateService
    ) {
        this.default = 0;
        this.idToLabelMap = [this.gfTranslateService.translate("Unlocked"), this.gfTranslateService.translate("Locked"), this.gfTranslateService.translate("Locked with Followups")];
        this.list = [
            {id: "00", value: "0", label: this.gfTranslateService.translate("Unlocked")},
            {id: "02", value: "2", label: this.gfTranslateService.translate("Followups Only")},
            {id: "01", value: "1", label: this.gfTranslateService.translate("Locked")}
        ];
    }

    public getList() {
        var lockStatusList = _.clone(this.list);
        return lockStatusList;
    }

    public idToValue(lockStatus) {
        if (!_.isEmpty(lockStatus)) {
            return _.find(this.list, {id: lockStatus})?.value ?? null;
        }
        return null;
    }
}


// Namespace: fields.builtIn.story_points
@Injectable()
export class TrackerFieldsStoryPointsService {
   
    constructor(
    ) {
    }

    public getStoryPointsOptionsList(storyPointsList: any, defaultSelected: number, includeLabel: boolean = true) {
        var ret = _.map(storyPointsList, (point: any) => {
            var el: any = {
                id: (_.isObject(point) ? _.get(point, 'id') : point),
            };

            if (includeLabel) {
                el.label = el.id;
            }

            if (point == defaultSelected) {
                el.defaultSelected = true;
            }

            return el;
        })
        return ret;
    }
}

// Namespace: fields.builtIn
@Injectable()
export class TrackerFieldsBuiltInService {
    priority: any;
    waiting_for: any;
    lock_status: any;
    story_points: any;

    constructor(private gfTranslateService: GfTranslateService) {
        this.priority = new TrackerFieldsPriorityService(this.gfTranslateService);
        this.waiting_for = new TrackerFieldsWaitingForService(this.gfTranslateService);
        this.lock_status = new TrackerFieldsLockStatusService(this.gfTranslateService);
        this.story_points = new TrackerFieldsStoryPointsService();
    }
}

// Namespace: fields.types
@Injectable()
export class TrackerFieldsTypesService {
    fieldTypes: any;

    constructor(private gfTranslateService: GfTranslateService) {
        this.fieldTypes =  {
            1: this.gfTranslateService.translate('Select'),
            2: this.gfTranslateService.translate('Checkbox'),
            3: this.gfTranslateService.translate('Radio'),
            4: this.gfTranslateService.translate('Text'),
            5: this.gfTranslateService.translate('Multiselect'),
            6: this.gfTranslateService.translate('Text area'),
            7: this.gfTranslateService.translate('Status'),
            8: this.gfTranslateService.translate('Release'),
            9: this.gfTranslateService.translate('Date'),
            10: this.gfTranslateService.translate('Numeric'),
            11: this.gfTranslateService.translate('Serial'),
            12: this.gfTranslateService.translate('Members'),
            13: this.gfTranslateService.translate('Carbon Copy')
        };
    }

    getDescription(id) {
        if (_.has(this.fieldTypes, id)) {
            return this.fieldTypes[id];
        }
        return '';
    }
}


// Namespace: fields
@Injectable()
export class TrackerFieldsService {
    builtIn: any;
    types: any;

    constructor(private gfTranslateService: GfTranslateService) {
        this.builtIn = new TrackerFieldsBuiltInService(this.gfTranslateService);
        this.types = new TrackerFieldsTypesService(this.gfTranslateService);
    }
   

    public isEnabled(tracker, field_id) {
        return _.get(tracker, 'fields[' + field_id + '].isEnabled' , false);
    }

    public removeNone(arrElements, isRole) {
        if (arrElements.length <= 1) return;

        if (isRole) {
            _.remove(arrElements, (element: any) => {
                return (element.id == 0);
            });
        } else {
            _.remove(arrElements, (element: any) => {
                return (element.alias == "");
            });
        }
    }

    public getSprintsGroupedByStatus(sprints: any) {
        var template = { current: [], unstarted: [], closed: [], none: [] };

        // Partition entries by the discriminant field
        var sorted = _.reduce(sprints.fieldElements, 
            (carry: any, item: any) => {
                switch (_.get(item, 'statusId', -1)) {
                    case 2: // closed
                        item.group = 'Closed';
                        carry.closed.push(item);
                        break;

                    case 1: // in progress
                        item.group = 'In Progress';
                        carry.current.push(item);
                        break;

                    case 0: // not started
                        item.group = 'Not Started';
                        carry.unstarted.push(item);
                        break;

                    default:
                        carry.none.push(item);
                        break;
                }
                return carry;
            }, template
        );

        // Custom sorting order
        return _.concat(
            sorted.none,
            sorted.current,
            sorted.unstarted,
            sorted.closed
        );
    }

    public getReleasesGroupedByStatus(releases: any) {
        var template = { unreleased: [], released: [], none: [] };

        // Partition entries by the discriminant field
        var sorted = _.reduce(releases.fieldElements, 
            (carry: any, item: any) => {
                switch (_.get(item, 'statusId', -1)) {
                    case 1: // released
                        item.group = 'Released';
                        carry.released.push(item);
                        break;

                    case 0: // unreleased
                        item.group = 'Unreleased';
                        carry.unreleased.push(item);
                        break;

                    default:
                        carry.none.push(item);
                        break;
                }
                return carry;
            }, template
        );

        // Custom sorting order
        return sorted.none.concat(
            sorted.unreleased,
            sorted.released
        );
    }

}